import type { ReactElement } from 'react';
import { memo } from 'react';
import { clsx } from 'clsx';
import type { TableDataProps } from './TableCell';
import type { TableRowProps } from './TableRow';
import styles from './Table.module.scss';

export interface TableBodyProps {
    /**
     * Override default vertical-align: middle property
     * to be baseline.
     */
    baselineAlign?: boolean;
    children:
        | ReactElement<TableRowProps | TableDataProps>
        | ReactElement<TableRowProps | TableDataProps>[];
}

const TableBody = ({ children, baselineAlign }: TableBodyProps) => {
    return (
        <tbody
            className={clsx(styles.tableBody, {
                [styles.baseline]: baselineAlign,
            })}
        >
            {children}
        </tbody>
    );
};

export default memo(TableBody);
